import React = require("react")
import { NewsletterForm } from "./newsletterFormBlockLayout"
import { NewsletterFormBlockProps } from "../../../custom_components/components/newsletter_block"

const newsletterBlock = (props: NewsletterFormBlockProps) => <NewsletterForm {...props} />

export default newsletterBlock